import React from 'react';
import { useAltHotkeys } from '../../hooks/useAltHotkeys';
import { useModalDrag } from '../../hooks/useModalDrag';
import ModalHeader from '../ui/ModalHeader';

export interface ClearDriverConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ClearDriverConfirmModal: React.FC<ClearDriverConfirmModalProps> = ({ isOpen, onCancel, onConfirm }) => {
  // Alt+C cancels; Remove gets no chord (it drops the arrival/depart dates).
  useAltHotkeys({ C: onCancel }, undefined, { layer: isOpen });

  const { panelRef, panelStyle, dragHandleProps } = useModalDrag(isOpen);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center" role="dialog" aria-label="Remove driver">
      <div className="absolute inset-0 bg-scrim/50" onClick={onCancel} />
      <div
        ref={panelRef}
        style={panelStyle}
        className="relative bg-panel rounded-lg shadow-xl max-w-sm w-full mx-4"
      >
        <ModalHeader title="Remove Driver" onClose={onCancel} dragHandleProps={dragHandleProps} />
        <div className="p-6">
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
          Removing this driver will remove the arrival/depart dates. Continue?
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-label bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md"
          >
            Remove
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default ClearDriverConfirmModal;
